<template>
  <div class="layout-header" :style="{ background: `url(${appData.platformConfiguration.topImg})` }">
    <div class="logo-header-box">
      <img :src="appData.platformConfiguration.websiteLogo" class="logo" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {};
  },
  computed: {
    appData() {
      return this.$store.state.appState.appData;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
